<template>
  <v-div class="WeblinkDisplay" relative pa-2>
    <v-div caption>{{ weblink.title }}</v-div>
    <v-div>
      <a :href="targetUrl" :aria-label="weblinkAriaLabel" target="_blank">
        <span>{{ targetUrl }}</span>
        <v-icon small color="primary" aria-hidden="true">{{
          mdiOpenInNew
        }}</v-icon>
      </a>
    </v-div>
    <v-div caption partially-transparent mt-2 mb-2>{{
      weblink.description
    }}</v-div>
  </v-div>
</template>

<script>
import { mdiOpenInNew } from "@mdi/js";

const matchHTTP = /^(http:|https:)\/\/?[a-z0-9]/;

export default {
  name: "WeblinkDisplay",
  props: {
    weblink: { type: Object, default: undefined },
  },
  data() {
    return {
      // Icons
      mdiOpenInNew,
    };
  },
  computed: {
    targetUrl() {
      const target = this.weblink.url;

      if (target.match(matchHTTP) === null) {
        return "http://" + target;
      }

      return target;
    },
    weblinkAriaLabel() {
      return `${this.weblink.title} [opens in a new tab]`;
    },
  },
};
</script>

<style>
.WeblinkDisplay a i {
  vertical-align: text-top;
}

.WeblinkDisplay a {
  overflow-wrap: break-word;
}
</style>
